import axiosInstance from '../utils/axiosInstance';

export const logout = async (nextRoute = '/') => {
  if (sessionStorage.getItem('token')) {
    try {
      await axiosInstance.delete('/token/invalidate');
    } catch (e) {
    } finally {
      sessionStorage.clear();
    }
  } else {
    sessionStorage.clear();
  }

  window.location.assign(nextRoute);
};
